module.exports = __webpack_public_path__ + "static/comuni-ciclabili-3636754ee8f57cd4fceb08a21e40d797.png";